/**
 * Finance / salary icon set (OO Зарплаты + Ставки) — cyberpunk line-icons,
 * currentColor, no emoji. 12–16px small glyphs to match v8icons style.
 */
import type { SVGProps } from "react";

type P = SVGProps<SVGSVGElement>;

function S({ vb = "0 0 16 16", sw = 1.4, fill = "none", children, ...rest }: P & { vb?: string; sw?: number }) {
  return (
    <svg viewBox={vb} fill={fill} stroke={fill === "none" ? "currentColor" : "none"} strokeWidth={sw} strokeLinecap="round" strokeLinejoin="round" {...rest}>
      {children}
    </svg>
  );
}

/** Такси — car silhouette. */
export const Taxi = (p: P) => (<S {...p}><path d="M2 11h12M3 11l1.4-4.2A2 2 0 0 1 6.3 5.4h3.4a2 2 0 0 1 1.9 1.4L13 11M3 11v2M13 11v2" /><circle cx="5" cy="11.4" r="0.6" fill="currentColor" /><circle cx="11" cy="11.4" r="0.6" fill="currentColor" /></S>);

/** Квест — theatre mask. */
export const Mask = (p: P) => (<S {...p}><path d="M3 4h10v4a5 5 0 0 1-10 0z" /><path d="M5.6 6.4h0M10.4 6.4h0M5.4 10c1.6 1.3 3.6 1.3 5.2 0" /></S>);

/** Шестерёнка — настройка периода. */
export const Gear = (p: P) => (<S {...p}><circle cx="8" cy="8" r="2.2" /><path d="M8 1.5v2M8 12.5v2M1.5 8h2M12.5 8h2M3.4 3.4l1.4 1.4M11.2 11.2l1.4 1.4M12.6 3.4l-1.4 1.4M4.8 11.2l-1.4 1.4" /></S>);

/** Расчётка — receipt / payslip. */
export const Receipt = (p: P) => (<S {...p}><path d="M4 1.5h8v13l-1.6-1-1.6 1-1.6-1L5.6 14l-1.6 1z" /><path d="M6 5h4M6 7.5h4M6 10h2.5" /></S>);

/** Монета ₽ — деньги-акцент. */
export const Coin = (p: P) => (<S {...p}><circle cx="8" cy="8" r="6" /><path d="M6.4 11V5h2.1a1.7 1.7 0 0 1 0 3.4H6.4M5.6 9.2h3" /></S>);

/** Транспонирование матрицы (квесты сверху). */
export const Transpose = (p: P) => (<S vb="0 0 16 16" sw={1.6} {...p}><path d="M3 6h7M3 6l2-2M3 6l2 2M13 10H6M13 10l-2-2M13 10l-2 2" /></S>);

/** Конверт — отправить в ТГ. */
export const Envelope = (p: P) => (<S {...p}><rect x="2" y="3.5" width="12" height="9" rx="1" /><path d="M2.6 4.2 8 8.6l5.4-4.4" /></S>);
